<div class="filter-chips-container">
  <mat-chip-list aria-label="Selected filter chips. Click to remove filter.">
    <h3 class="results-label-h3 filters-label">Filters: </h3>
    <mat-chip *ngFor="let chip of formFactorFilterChips" (removed)="removeFormFactorFilter(chip.value)">
      <span class="filter-chip-label">{{chip.label}}</span>
      <mat-icon matChipRemove>clear</mat-icon>
    </mat-chip>
    <mat-chip *ngFor="let chip of screenSizeFilterChips" (removed)="removeScreenSizeFilter(chip.value)">
      <span class="filter-chip-label">{{chip.label}}</span>
      <mat-icon matChipRemove>clear</mat-icon>
    </mat-chip>
    <mat-chip *ngFor="let chip of brandFilterChips" (removed)="removeBrandFilter(chip.value)">
      <span class="filter-chip-label">{{chip.label}}</span>
      <mat-icon matChipRemove>clear</mat-icon>
    </mat-chip>
    <mat-chip *ngFor="let chip of featureFilterChips" (removed)="removeFeatureFilter(chip.value)">
      <span class="filter-chip-label">{{chip.label}}</span>
      <mat-icon matChipRemove>clear</mat-icon>
    </mat-chip>
    <mat-chip *ngFor="let chip of availabilityFilterChips" (removed)="removeAvailabilityFilter(chip.value)">
      <span class="filter-chip-label">{{chip.label}}</span>
      <mat-icon matChipRemove>clear</mat-icon>
    </mat-chip>
    <mat-chip *ngFor="let chip of chromebookPlusFiltersChips" (removed)="removeChromebookPlusFilter(chip.value)">
      <span class="filter-chip-label">{{chip.label}}</span>
      <mat-icon matChipRemove>clear</mat-icon>
    </mat-chip>
    <ng-container *ngIf="isEnterpriseWorkflow">
      <mat-chip *ngFor="let chip of osTypeFilterChips" (removed)="removeOsTypeFilter(chip.value)">
        <span class="filter-chip-label">{{chip.label}}</span>
        <mat-icon matChipRemove>clear</mat-icon>
      </mat-chip>
    </ng-container>
  </mat-chip-list>
</div>
